module.exports = __webpack_public_path__ + "static/media/danskeheadline-webfont.848a35e8.eot";